import React from "react";
import { Container, makeStyles, Button } from "@material-ui/core";
import { useRouter } from "next/router";

import FunnelHeader from "components/header/funnelHeader";
import Stepper from "ui/stepper/Stepper";
import { CollectFunnelAddressFormStep } from "components/collectFunnel/steps/collectFunnelAddressFormStep/CollectFunnelAddressFormStep";
import { CollectFunnelDateStep } from "components/collectFunnel/steps/collectFunnelDateStep/CollectFunnelDateStep";
import { CollectFunnelProductChoiceStep } from "components/collectFunnel/steps/collectFunnelProductChoiceStep/CollectFunnelProductChoiceStep";
import { CollectFunnelInformationStep } from "components/collectFunnel/steps/collectFunnelInformationStep/CollectFunnelInformationStep";
import { CollectFunnelConfirmationStep } from "components/collectFunnel/steps/collectFunnelConfirmationStep/CollectFunnelConfirmationStep";
import { STEPS, STEPS_NAMES, URL_TO_STATE, STEP_ADDRESS } from "components/collectFunnel/constants";
import { CollectFunnelProvider } from "components/collectFunnel/CollectFunnelProvider";
import ArrowLeft from "components/repairFunnel/assets/arrowLeft.svg";
import SeoCollect from "components/seo/rendez-vous-collecte";

const MURFY_HOMEPAGE_URL = "https://murfy.fr";

export default function Date() {
  const classes = useStyle();
  const router = useRouter();
  const activeStep = React.useMemo(() => URL_TO_STATE[router.query.state], [router]);
  const displayedSteps = STEPS;
  const displayedStepNames = STEPS_NAMES;

  React.useEffect(() => {
    if (!activeStep && router.query.state) {
      router.push(STEP_ADDRESS.url);
    }
  }, [router, activeStep]);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SeoCollect />
      <div className={classes.container}>
        <CollectFunnelProvider>
          <FunnelHeader
            logoHref={MURFY_HOMEPAGE_URL}
            cta={
              <Button color="secondary" startIcon={<ArrowLeft />} href={MURFY_HOMEPAGE_URL}>
                Revenir à l&rsquo;accueil
              </Button>
            }
          >
            <Stepper steps={displayedSteps} stepsNames={displayedStepNames} activeStep={activeStep} />
          </FunnelHeader>
          {activeStep === 1 && <CollectFunnelAddressFormStep />}
          <Container className={classes.inner} disableGutters>
            {activeStep === 2 && <CollectFunnelProductChoiceStep />}
            {activeStep === 3 && <CollectFunnelDateStep />}
            {activeStep === 4 && <CollectFunnelInformationStep />}
            {activeStep === 5 && <CollectFunnelConfirmationStep />}
          </Container>
        </CollectFunnelProvider>
      </div>
    </>
  );
}

const useStyle = makeStyles(() => ({
  container: {
    position: "relative",
  },
  inner: {
    maxWidth: 1120,
  },
}));
